import { gql } from '@apollo/client'
import { useDocument, useRole } from '@ztechapps/common.hook'
import { orderPermissions } from '../../permission/orderPermissions'
import { OrderStatusEnum } from '@ztechapps/common.contract'

const getMyOrderStatusQuery = gql`
  query getMyOrder($filter: JSON) {
    getMyOrder(filter: $filter) {
      _id
      status
    }
  }
`

type UseCanCancelProps = { orderId: string }

export const useCanCancelOrder = ({ orderId }: UseCanCancelProps): boolean => {
  const { hasRole } = useRole({ roleName: orderPermissions.canEdit.value })
  const { document } = useDocument({
    query: getMyOrderStatusQuery,
    options: {
      queryOptions: {
        skip: !orderId,
      },
    },
    _id: orderId ?? null,
  })

  return (
    document?.status !== OrderStatusEnum.Cancelled &&
    document?.status !== OrderStatusEnum.Delivered &&
    document?.status !== OrderStatusEnum.InTransit &&
    hasRole
  )
}
